import _ from "lodash";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { UiMeta } from "../FrmSpwkQuestV3/UiMeta";
import { UniOption } from "../../dao/UniOption";
import { SpwkMetaData_DataType } from "../../export_spwk/SpwkMetaData";
import { Project } from "../../dao/Project";
import { UniAnswer } from "../../dao/UniAnswer";
import { Member } from "../../dao/Member";
import dayjs from "dayjs";
import { UniInput } from "../../dao/UniInput";


/** 
 * 類似這樣的分數對照表
 * {
        "沒有或極少": "0",
        "有時": "1",
        "時常": "2",
        "常常/總是": "3",
      }
 */
export type Table = Record<string, string>;

export type YesNoRule = {
  true_val: "是" | "有";
  false_val: "否" | "無";
  unknown_val: "否" | "無" | "未填寫";
};

export const UNKNOWN: string = "(XXXXX)";

export class CommonExportUtil {

  static GetVal(rhf_data: any, rhf_name: string): any {
    let val = _.get(rhf_data, rhf_name);
    return val;
  }

  static GetString(rhf_data: any, rhf_name: string): string {
    let val = _.get(rhf_data, rhf_name);
    if (val == null) {
      return "";
    } else {
      return "" + val;
    }
  }

  static GetBool(rhf_data: any, rhf_name: string): boolean | undefined {
    let val = _.get(rhf_data, rhf_name);
    if (val == null) {
      return undefined;
    } else {
      if (val === true) {
        return true;
      } else if (val === false) {
        return false;
      } else {
        throw new_ErrorAlert("434341313: GeGetBool() 應該是 true or false");
      }
    }
  }



  /** 如果答案是 undefined或null回傳XXX, false 將它回傳成 "否" , 是 true 的回傳"是" */
  static GetBool_CheckBox(rhf_data: any, rhf_name: string, 是否RULE: YesNoRule): string {
    let val = CommonExportUtil.GetBool(rhf_data, rhf_name);

    if (val == null) {
      return 是否RULE.unknown_val;
    } else {
      if (val === true) {
        return 是否RULE.true_val;
      } else if (val === false) {
        return 是否RULE.false_val;
      } else {
        throw new_ErrorAlert("156544445: GetBool_CheckBox() val 未預期");
      }
    }
  }



  /** 找到指定題目的單選項目 meta (有勾選的)，(找不到題目或，如果一個沒有勾選，則回傳 null) */
  static GetMeta_SelRadio(meta_table: UiMetaTable, rhf_data: any, rhf_name: string) {
    let q_meta_list = meta_table.FilterMetas_ByRhfName(rhf_name);

    if (q_meta_list == null || q_meta_list.length === 0) {
      return null;// 查無此題
    }

    if (q_meta_list.length > 1) {
      throw new_ErrorAlert("46846310 特作 合併多張 才可能會有重複的 rhf_name !!!");
    }

    let q_meta = q_meta_list[0];

    if (q_meta.Is單選題目() === false) {
      throw new_ErrorAlert("4164166 預期要是單選題 !!!");
    }

    let val = CommonExportUtil.GetVal(rhf_data, rhf_name);
    if (val == null) {
      return null;// 沒有此題答案
    }

    let option_metas = meta_table.FilterOptionMetas_ByQuestionGuid(q_meta.question_guid);

    let sel_metas = option_metas.filter(x => x.option_code === ("" + val));
    if (sel_metas.length === 1) {
      return sel_metas[0];
    } else if (sel_metas.length === 0) {
      throw new_ErrorAlert("494918 找不到對應的單選選項 !!!: " + val + "\r\nrhf_name: " + q_meta.rhf_name);
    } else {
      throw new_ErrorAlert("58946 重複的單選選項 !!!");
    }

  }

  /** 找到指定題目的多選項目 metas (有勾選的)，(找不到題目或，如果一個都沒有勾選，則回傳 []) */
  static GetMeta_SelChecks(meta_table: UiMetaTable, rhf_data: any, rhf_name: string) {
    let q_meta_list = meta_table.FilterMetas_ByRhfName(rhf_name);

    if (q_meta_list == null || q_meta_list.length === 0) {
      return [];// 查無此題
    }

    if (q_meta_list.length > 1) {
      throw new_ErrorAlert("494941610 特作 合併多張 才可能會有重複的 rhf_name !!!");
    }

    let q_meta = q_meta_list[0];

    if (q_meta.Is多選題目() === false) {
      throw new_ErrorAlert("469464168 預期要是多選題 !!!");
    }

    let option_metas = meta_table.FilterOptionMetas_ByQuestionGuid(q_meta.question_guid);

    let sel_meta_list = [];
    for (const meta of option_metas) {
      let check = CommonExportUtil.GetBool(rhf_data, meta.rhf_name);
      if (check != null && check === true) {
        sel_meta_list.push(meta);
      }
    }

    return sel_meta_list;

  }



  /**
   * 配合 GetMeta_SelRadio 使用
   * 取得指定欄位 或 預設值
   * 
   *  範例: 回傳單選的 
   *  let meta_rdo = Util.GetMeta_SelRadio(meta_table, rhf_data, "m03.工作型態以下選項是否有符合");
   * 
   * 
   */
  static GetOptionMeta_Property(prop_name: MetaPropName, opt_meta: UiMeta | null, null_value: string = ""): string {
    if (opt_meta == null) {
      return null_value;// 遇到 null 時的預設值 (可能是沒有勾選)
    }

    if (opt_meta.data_type !== SpwkMetaData_DataType.Option) {
      throw new_ErrorAlert("4684313 預期應該是選項 !!!");
    }

    if (prop_name === MetaPropName.option_title) {
      return (opt_meta.data_obj as UniOption).option_title
        ;
    } else if (prop_name === MetaPropName.option_code) {
      return ("" + opt_meta.option_code);

    } else if (prop_name === MetaPropName.data_serno) {
      return ("" + opt_meta.data_serno);

    } else if (prop_name === MetaPropName.o_his_code) {
      return (opt_meta.data_obj as UniOption).o_his_code;

    } else if (prop_name === MetaPropName.o_gov_code) {
      return (opt_meta.data_obj as UniOption).o_gov_code;

    } else {
      throw new_ErrorAlert("未知或不支援的 MetaPropName !!!");
    }

  }

  /**
  * 配合 GetMeta_SelChecks 使用
  * 取得指定欄位 並以 splitor 符號分隔
  */

  /**
   * 給定一票選項列表，如: 回傳上面的文字，如果遇到填寫的部分，則取代對應的 {_1_}、{_2_}、{_3_}...
   */
  static GetCheckLabels_WithInput(meta_table: UiMetaTable, rhf_data: any, option_meta_list: UiMeta[]): string[] {

    let items: string[] = [];

    for (const opt_meta of option_meta_list) {
      if (opt_meta.data_obj instanceof UniOption) {
        // pass;
      } else {
        throw new_ErrorAlert("預期 meta 要是 UniOption 選項!!! ");
      }

      let opt_label = (opt_meta.data_obj as UniOption).option_title;

      if (opt_label.includes("{_") && opt_label.includes("_}")) {
        opt_label = CommonExportUtil.GetOneOptionLabel_WithInput(meta_table, rhf_data, opt_meta);
      }

      items.push(opt_label);
    }

    return items;
  }


  /** 指定一個選項，將input內的文字串好 */
  static GetOneOptionLabel_WithInput(meta_table: UiMetaTable, rhf_data: any, opt_meta: UiMeta): string {

    let opt_label = (opt_meta.data_obj as UniOption).option_title;

    let input_metas = meta_table.FilterInputMetas_ByOptionGuid(opt_meta.data_guid);

    for (const input_meta of input_metas) {
      let input_code = (input_meta.data_obj as UniInput).input_code;

      let str = CommonExportUtil.GetString(rhf_data, input_meta.rhf_name);

      opt_label = opt_label.replaceAll("{_" + input_code + "_}", str);
    }

    return opt_label;
  }




  /**
   * 主要是指定 rhf_name 取得資料中的 meta_data
   * 從 meta 中的 option_code 找出對應的分數，回傳對應的分數
   * 
   */
  static OptionValue(meta_table: UiMetaTable, rhf_data: any, rhf_name: string,
    unknown_val: string, key_val_table: Table | null
  ) {

    let unimeta = CommonExportUtil.GetMeta_SelRadio(meta_table, rhf_data, rhf_name);
    let re_option_code = CommonExportUtil.GetOptionMeta_Property(MetaPropName.option_code, unimeta);

    if (key_val_table == null) {
      return re_option_code;// 使用 option_code 當作顯示的文字

    } else {

      if (re_option_code == null) {
        return unknown_val;// 未填寫

      } else {
        let score = key_val_table[re_option_code];
        if (score != null) {
          return score;// 查詢分數對照表，回傳對應的文字

        } else {
          //alert('1224545 key_val_table[re_option_code] 為 undefined 或 null\n找不到對應的分數:' + score + "=??");
          //找不到時把答案塗成unknown_val
          return unknown_val;
        }
      }

    }

  }


  //#region 綠色 通用標題
  static 填寫日期(sel_ans: UniAnswer): string {
    let rec_dt = dayjs(sel_ans.rec_dt);
    if (rec_dt.isValid() === false) {
      return UNKNOWN;
    } else if (rec_dt.year() <= 1800 || rec_dt.year() >= 2999) {
      return UNKNOWN;
    } else {
      return rec_dt.format("YYYY-MM-DD");
    }
  }


  static 項次(): string {
    return "";// 04/25 討論後，統一空白，之後他們會用 Excel 自己拉序號
  }

  static 廠區(project: Project): string {
    return project.project_name;// 04/25 討論後，統一以場次名稱為準
  }

  static 部門代號(): string {
    return "";// 04/25 討論後，統一空白，他們自己依照當初開單時的部門名稱 用 Excel 湊
  }

  /**取得該ans的member部門名稱*/
  static 部門名稱(sel_member: Member | undefined): string {
    if (sel_member == null) {
      return UNKNOWN;
    }

    return sel_member.department;
  }

  static 工號(sel_member: Member | undefined): string {
    if (sel_member == null) {
      return UNKNOWN;
    }

    return sel_member.employee_id;
  }

  static 姓名(sel_member: Member | undefined): string {
    if (sel_member == null) {
      return UNKNOWN;
    }

    return sel_member.member_name;
  }

  static 健檢日期(sel_member: Member | undefined): string {
    if (sel_member == null) {
      return UNKNOWN;
    }

    // return "(TODO) 帶入 member 的檢查日期" + UNKNOWN;
    let rec_dt = sel_member.rec_dt;
    if (rec_dt == null || rec_dt === "") {
      return UNKNOWN;
    }

    let day = dayjs(rec_dt);
    if (!day.isValid()) {
      return UNKNOWN;
    }

    if (day.year() === 2999) {
      return UNKNOWN;
    }

    return day.format("YYYY/MM/DD");


  }


  static 性別(ans: UniAnswer, sel_member: Member | undefined): string {
    if (sel_member == null) {
      return UNKNOWN;
    }

    if (sel_member.gender === 1) {
      return "男";
    } else if (sel_member.gender === 2) {
      return "女";
    } else if (sel_member.gender === 0) {
      return "";
    } else {
      alert('121322, 不是預料的gender值: ' + sel_member.gender);
      return "";
    }
  }

}

export enum MetaPropName {
  option_title,
  data_serno,
  option_code,
  o_his_code,
  o_gov_code
}